import {
  AppConfigurationVariable as ConfigurationVariable,
  ConfigurationBooleanValue,
  ConfigurationVariableType
} from 'graphql/models/extended';
import { ConfigurationVariableValue } from 'graphql/models/generated';

import { isCalculatedValue } from './is-calculated-value';

export function mapConfigurationVariable(item: ConfigurationVariable): ConfigurationVariable {
  const assignedValue = (item.values || []).find((v: ConfigurationVariableValue) => (
    v.assigned != null
  ));

  const disabled = (
    (item.disabledProp && item.disabledProp.valueText === ConfigurationBooleanValue.TRUE)
    || isCalculatedValue(item)) || false;
  let showAs = (item.showAsProp && item.showAsProp.valueText) || 'DropDown';

  const show = (!(item.showInConfiguration
    && item.showInConfiguration.valueText === ConfigurationBooleanValue.FALSE));

  const required = (item.requiredProp
    && item.requiredProp.valueText === ConfigurationBooleanValue.TRUE) || false;

  const assigned = (assignedValue || { assigned: undefined }).assigned;
  const valueName = (assignedValue || { name: undefined }).name;

  let value!: string | number | undefined;
  if (isCalculatedValue(item)) {
    value = (item.calculatedValue && item.calculatedValue.valueText) || '';
    showAs = 'InputField';
  } else if (item.valueType && item.valueType === ConfigurationVariableType.NUMBER) {
    value = (assignedValue || { numberValue: undefined }).numberValue;
    showAs = 'InputField';
  } else {
    value = (assignedValue || { value: undefined }).value;
  }

  return {
    ...item,
    value,
    valueName,
    showAs,
    show,
    disabled,
    assigned,
    required
  } as ConfigurationVariable;
}
